import { render, staticRenderFns } from "./IconRewind.vue?vue&type=template&id=fde427ba"
import script from "./IconRewind.vue?vue&type=script&lang=js"
export * from "./IconRewind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports